import {
    apiRequest,
    exportExcel,
} from "../../../../../services/adapters/kepegawaian/pensiunService"

class IndexRepository {

    fetchExportExcel = async (query) => {
        return await apiRequest("get", exportExcel, {
            params: query
        }, true)
    }

  
}

export default IndexRepository